<template>
  <div class="container-main-body">
    <!--按钮开始-->
    <div class="list-container">
      <div v-if="searchShow" class="search-container">
        <el-row>
          <el-col :span="6">
            <div class="search-form-label">类别：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="类别"
                clearable
                v-model="queryData.category"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="search-form-label">库位：</div>
            <div class="search-form-controller">
              <el-input
                size="mini"
                placeholder="库位"
                clearable
                v-model="queryData.position"
              ></el-input>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" style="text-align: center;">
            <el-button
              type="warning"
              size="mini"
              icon="el-icon-search"
              plain
              @click="searchHandler"
              >开始搜索</el-button
            >
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              plain
              @click="searchHandler('clear')"
              >清空</el-button
            >
            <el-button
              type="danger"
              size="mini"
              icon="el-icon-close"
              plain
              @click="showSearchHandler()"
              >关闭搜索</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="list-btns-container">
        <el-button-group>
          <el-button
            v-for="btn in $store.state.currentLBtnList"
            :key="btn.id"
            :type="btn.button_type"
            size="mini"
            :icon="btn.button_icon"
            @click="handlerButtonDispatch(btn.fn)"
            >{{ btn.button_name }}</el-button
          >
          <el-button
            size="mini"
            style="margin-left: 1px;"
            @click="printMaterianHandle"
            >打印所有资材库位</el-button
          >
        </el-button-group>
      </div>
      <!--按钮结束-->
      <!--列表数据 开始-->
      <div class="el-table-container">
        <el-table
          :data="ds"
          size="mini"
          stripe
          border
          height="100%"
          style="width: 100% border:1px solid #d1d1d1"
          header-row-class-name="list-header-row"
          row-class-name="list-row"
        >
          <el-table-column
            label="类别"
            prop="category"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column
            label="库位"
            prop="position"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column></el-table-column>
          <el-table-column label="操作" width="60" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-printer"
                circle
                plain
                @click.stop.prevent="printHandler(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination
          background
          :current-page="queryData.pn"
          :page-size="queryData.pageSize"
          :total="queryData.totalCount"
          :page-sizes="[10, 15, 20, 25, 30, 50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChange"
          @current-change="pageChange"
        ></el-pagination>
      </div>
    </div>
    <div
      id="print_area"
      style="position: relative; z-index: -1;text-align:center;font-family: '微软雅黑';font-weight: bold;"
    >
      <div style="font-size:30pt">类别：{{ categoryValue }}</div>
      <div style="font-size:30pt">库位：{{ positionName }}</div>
      <div ref="codeItem" style="margin-top:10px"></div>
    </div>
    <div
      id="print_area_material"
      style="position: relative; z-index: -1;text-align:center;font-family: '微软雅黑';font-weight: bold;"
    >
      <template v-for="(item, index) in materialList">
        <div style="font-size:30pt;">类别：{{ item.category }}</div>
        <div style="font-size:30pt">库位：{{ item.position }}</div>
        <div
          :id="'codeItem' + index"
          style="margin-top:10px;page-break-after:always"
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
export default {
  data: function() {
    return {
      ds: [],
      materialList: [],
      fullscreenLoading: false,
      queryData: {
        category: "",
        position: "",
        pn: 1, // 页码
        pageSize: 20, // 每页条数
        totalCount: 0 // 数据总条数
      },
      searchShow: false,
      operator_id: sessionStorage.getItem("operator_id"),
      positionName: "",
      categoryValue: ""
    };
  },
  created: function() {},
  mounted: function() {
    this.loadData();
  },
  methods: {
    // 按钮 点击 调度方法
    handlerButtonDispatch: function(fn, args) {
      var _this = this;
      if (typeof _this[fn] === "function") {
        _this[fn].apply(_this, args);
      } else {
        console.log("warning: the method is not exist");
      }
    },
    // 加载数据
    loadData: function() {
      let _this = this;
      _this.post(_this.$apis.getPrintPositionList, this.queryData, function(
        res
      ) {
        let _json = res.data;
        if (_json.status && _json.status === "logout") {
          _this.logout();
        } else {
          _this.ds = _json.datalist;
          _this.queryData.totalCount = _json.totalCount;
          _this.materialList = _json.materialList;
        }
      });
    },
    printMaterianHandle: function() {
      for (let i = 0; i < this.materialList.length; i++) {
        this.drawCode(i);
      }
      setTimeout(() => {
        const style =
          "@page { margin-top: 40% } @media print { h1 { color: blue } img {margin: 0 auto;}}";
        this.$print({
          printable: "print_area_material",
          type: "html",
          style: style,
          scanStyles: false
        });
      }, 200);
    },
    async drawCode(i) {
      let el = document.getElementById("codeItem" + i);
      await new QRCode(el, {
        // 二维码内容
        text:
          "K," + this.materialList[i].position + "," + this.materialList[i].id,
        width: 300,
        height: 300,
        // 二维码颜色
        colorDark: "#333333",
        // 二维码背景色
        colorLight: "#ffffff"
      });
    },
    // 浏览
    printHandler: function(_row) {
      this.categoryValue = _row.category;
      this.positionName = _row.position;
      this.$refs.codeItem.innerHTML = "";
      new QRCode(this.$refs.codeItem, {
        // 二维码内容
        text: "K," + _row.position + "," + _row.id,
        width: 300,
        height: 300,
        // 二维码颜色
        colorDark: "#333333",
        // 二维码背景色
        colorLight: "#ffffff"
      });
      setTimeout(() => {
        const style =
          "@page { margin-top: 40% } @media print { h1 { color: blue } img {margin: 0 auto;}}";
        this.$print({
          printable: "print_area",
          type: "html",
          style: style,
          scanStyles: false
        });
      }, 200);
    },
    searchHandler: function(_type) {
      this.queryData.pn = 1;
      if (_type === "clear") {
        (this.queryData.position = ""), (this.queryData.category = "");
      }
      this.loadData();
    },
    showSearchHandler: function() {
      this.searchShow = !this.searchShow;
    },
    // 刷新事件
    refreshHandler: function() {
      this.loadData();
    },
    // 页码改变
    pageSizeChange: function(pageSize) {
      this.queryData.pn = 1;
      this.queryData.pageSize = pageSize;
      this.loadData();
    },
    pageChange: function(pn) {
      this.queryData.pn = pn;
      this.loadData();
    }
  },
  components: {}
};
</script>
